import {Box, Dialog, DialogContent} from "@mui/material";
import {
  Button, DialogTitle,
  Field,
  FieldsContainer,
  Form,
  PasswordField,
  Spacer,
  TextField,
  Toolbar,
} from "common";
import I18n from "i18n-js";
import useProfileFrom from "./useProfileFrom";
import React from "react";
import useChangePasswordForm from "./useChangePasswordForm";
import {ChangePasswordForm} from "./profileAPI";
import ChangeEmailRequestDialog from "./changeEmailRequest/changeEmailRequestDialog";

export default function MyProfile() {
  const {item, errors, loading, onChange, updateProfile, getIsDirty} =
    useProfileFrom();

  const {
    showChangePasswordForm,
    setShowChangePasswordForm,
    setChangePasswordItem,
    changePasswordItem,
    changePasswordErrors,
    setChangePasswordErrors,
    onChangePasswordChange,
    processChangePassword,
    changePasswordLoading,
  } = useChangePasswordForm({});

  return (
    <Box maxWidth="sm">
      <Form
        item={item}
        errors={errors}
        onChange={onChange}
        translationCategory="Profile.attributes"
        isDirty={getIsDirty}
      >
        <FieldsContainer>
          <Field xs={12} md={12}>
            <TextField id="first_name"/>
          </Field>
          <Field xs={12} md={12}>
            <TextField id="last_name"/>
          </Field>
        </FieldsContainer>
      </Form>
      <Spacer h={2}/>
      <Toolbar>
        <Button
          variant="text"
          title={I18n.t("Profile.changePasswordTitle")}
          onClick={() => {
            setChangePasswordItem({} as ChangePasswordForm);
            setChangePasswordErrors({});
            setShowChangePasswordForm(true);
          }}
        />

        <ChangeEmailRequestDialog />

        <Dialog
          open={showChangePasswordForm}
          onClose={() => setShowChangePasswordForm(false)}
        >
          <DialogTitle
            onClose={() => {
              setShowChangePasswordForm(false);
            }}
          >
            {I18n.t("Profile.changePasswordTitle")}
          </DialogTitle>
          <DialogContent>
            <Form
              item={changePasswordItem}
              errors={changePasswordErrors}
              onChange={onChangePasswordChange}
              translationCategory="Profile.attributes"
            >
              <FieldsContainer>
                <Field fullWidth>
                  <Spacer h={2} />
                  <PasswordField fake id="password" />
                </Field>
                <Field fullWidth>
                  <PasswordField fake id="newPassword" />
                </Field>
              </FieldsContainer>
            </Form>
            <Spacer h={2} />
            <Toolbar>
              <Spacer right />
              <Button
                title={I18n.t("App.save")}
                loading={changePasswordLoading}
                onClick={() => processChangePassword()}
              />
            </Toolbar>
          </DialogContent>
        </Dialog>

        <Spacer right/>
        <Button
          loading={loading}
          onClick={() => updateProfile()}
          disabled={!getIsDirty()}
        >
          {I18n.t("App.save")}
        </Button>
      </Toolbar>
    </Box>
  );
}
